/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import FormField from "components/FormField";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SwitchField from "components/SwitchField";

export default function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { organizeName, taxId } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={organizeName.type}
            name={organizeName.name}
            label={organizeName?.label}
            value={values.organizeName}
            error={errors.organizeName && touched.organizeName}
            success={values.organizeName?.toString().length > 0 && !errors.organizeName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            type={taxId.type}
            name={taxId.name}
            label={taxId?.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
